/// <amd-module name="Test/TestResultHistory/TelemetryConstants" />
export const featureTestHistory_HistoryPaneViewed: string = "TestHistory_HistoryPaneViewed";
export const featureTestHistory_BranchFilterCleared: string = "TestHistory_BranchFilterCleared";
export const featureTestHistory_BranchFilterUsed: string = "TestHistory_BranchFilterUsed";
export const featureTestHistory_LeftOrRightArrowClicked: string = "TestHistory_LeftOrRightArrowClicked";